<template>
   <div>
      <crud-toolbar :isBlocked="formData.blocked" :modal-mode="modalMode" :new-state="newState"
                    :title="modalTitle" @onCommand="toolbarCommand"
                    showBlock></crud-toolbar>

      <crud-form :modal-mode="modalMode" :ref="formName" v-model="validForm">

         <v-layout row wrap>
            <a-text-field label="Nome do Banco" v-model="formData.name"></a-text-field>
            <a-text-field label="Código do Banco" v-mask="['###', '###-#']" v-model="formData.bankNo"></a-text-field>
         </v-layout>
      </crud-form>
   </div>
</template>

<script>
   import CrudFormClass from '@consigmais-team/vue-common/layout/crudPage/crudFormClass';

   export default CrudFormClass.extend({
      name: 'bankForm',

      data () {
         return {
            title: 'Banco',
            formName: 'bankForm',
            formData: {
               id: null,
               name: null,
               bankNo: null
            }
         };
      }

   });
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/BankForm.vue